<div class="step2-channels">
  <h3 class="step-title">
    <i class="pi pi-send"></i>
    Configuración de Canales de Comunicación
  </h3>
  
  <!-- Mensaje de validación -->
  <div class="validation-alert" *ngIf="validationMessage">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ validationMessage }}</span>
  </div>
  
  <!-- Configuración de Canales -->
  <form [formGroup]="channelsForm" class="channels-form">
    <div class="channels-grid">
      <!-- Email Channel -->
      <div class="channel-card" [class.active]="isChannelEnabled('email')" [formGroupName]="'email'">
        <div class="channel-header">
          <div class="channel-info">
            <i [class]="channelIcons.email" class="channel-icon email-icon"></i>
            <h4>{{ channelLabels.email }}</h4>
          </div>
          <p-inputSwitch formControlName="enabled" (onChange)="onChannelToggle('email')"></p-inputSwitch>
        </div>
        
        <div class="channel-body" *ngIf="isChannelEnabled('email')">
          <div class="channel-fields-row">
            <div class="form-field">
              <label>Hora de inicio <span class="required">*</span></label>
              <input 
                type="time" 
                pInputText 
                formControlName="scheduledTime"
                class="w-full"
              />
            </div>
            
            <div class="form-field">
              <label>Frecuencia diaria</label>
              <p-inputNumber
                formControlName="frequency"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="1"
                [max]="frequencyConfig.MAX_FREQUENCY"
                suffix=" veces"
                [style]="{'width': '100%'}"
                (onInput)="onFrequencyChange('email')"
              ></p-inputNumber>
            </div>
          </div>
          
          <!-- Intervalo (solo si frequency > 1) -->
          <div class="interval-section" *ngIf="hasMultipleFrequency('email')">
            <div class="form-field">
              <label>Intervalo entre envíos</label>
              <p-inputNumber
                formControlName="frequencyInterval"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="frequencyConfig.MIN_INTERVAL"
                [max]="480"
                suffix=" min"
                [style]="{'width': '50%'}"
              ></p-inputNumber>
            </div>
          </div>
        </div>
      </div>
      
      <!-- SMS Channel -->
      <div class="channel-card" [class.active]="isChannelEnabled('sms')" [formGroupName]="'sms'">
        <div class="channel-header">
          <div class="channel-info">
            <i [class]="channelIcons.sms" class="channel-icon sms-icon"></i>
            <h4>{{ channelLabels.sms }}</h4>
          </div>
          <p-inputSwitch formControlName="enabled" (onChange)="onChannelToggle('sms')"></p-inputSwitch>
        </div>
        
        <div class="channel-body" *ngIf="isChannelEnabled('sms')">
          <div class="channel-fields-row">
            <div class="form-field">
              <label>Hora de inicio <span class="required">*</span></label>
              <input 
                type="time" 
                pInputText 
                formControlName="scheduledTime"
                class="w-full"
              />
            </div>
            
            <div class="form-field">
              <label>Frecuencia diaria</label>
              <p-inputNumber
                formControlName="frequency"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="1"
                [max]="frequencyConfig.MAX_FREQUENCY"
                suffix=" veces"
                [style]="{'width': '100%'}"
                (onInput)="onFrequencyChange('sms')"
              ></p-inputNumber>
            </div>
          </div>
          
          <!-- Intervalo (solo si frequency > 1) -->
          <div class="interval-section" *ngIf="hasMultipleFrequency('sms')">
            <div class="form-field">
              <label>Intervalo entre envíos</label>
              <p-inputNumber
                formControlName="frequencyInterval"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="frequencyConfig.MIN_INTERVAL"
                [max]="480"
                suffix=" min"
                [style]="{'width': '50%'}"
              ></p-inputNumber>
            </div>
          </div>
        </div>
      </div>
      
      <!-- WhatsApp Channel -->
      <div class="channel-card" [class.active]="isChannelEnabled('whatsapp')" [formGroupName]="'whatsapp'">
        <div class="channel-header">
          <div class="channel-info">
            <i [class]="channelIcons.whatsapp" class="channel-icon whatsapp-icon"></i>
            <h4>{{ channelLabels.whatsapp }}</h4>
          </div>
          <p-inputSwitch formControlName="enabled" (onChange)="onChannelToggle('whatsapp')"></p-inputSwitch>
        </div>
        
        <div class="channel-body" *ngIf="isChannelEnabled('whatsapp')">
          <div class="channel-fields-row">
            <div class="form-field">
              <label>Hora de inicio <span class="required">*</span></label>
              <input 
                type="time" 
                pInputText 
                formControlName="scheduledTime"
                class="w-full"
              />
            </div>
            
            <div class="form-field">
              <label>Frecuencia diaria</label>
              <p-inputNumber
                formControlName="frequency"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="1"
                [max]="frequencyConfig.MAX_FREQUENCY"
                suffix=" veces"
                [style]="{'width': '100%'}"
                (onInput)="onFrequencyChange('whatsapp')"
              ></p-inputNumber>
            </div>
          </div>
          
          <!-- Intervalo (solo si frequency > 1) -->
          <div class="interval-section" *ngIf="hasMultipleFrequency('whatsapp')">
            <div class="form-field">
              <label>Intervalo entre envíos</label>
              <p-inputNumber
                formControlName="frequencyInterval"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="frequencyConfig.MIN_INTERVAL"
                [max]="480"
                suffix=" min"
                [style]="{'width': '50%'}"
              ></p-inputNumber>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Call Channel -->
      <div class="channel-card" [class.active]="isChannelEnabled('call')" [formGroupName]="'call'">
        <div class="channel-header">
          <div class="channel-info">
            <i [class]="channelIcons.call" class="channel-icon call-icon"></i>
            <h4>{{ channelLabels.call }}</h4>
          </div>
          <p-inputSwitch formControlName="enabled" (onChange)="onChannelToggle('call')"></p-inputSwitch>
        </div>
        
        <div class="channel-body" *ngIf="isChannelEnabled('call')">
          <div class="channel-fields-row">
            <div class="form-field">
              <label>Hora de inicio <span class="required">*</span></label>
              <input 
                type="time" 
                pInputText 
                formControlName="scheduledTime"
                class="w-full"
              />
            </div>
            
            <div class="form-field">
              <label>Frecuencia diaria</label>
              <p-inputNumber
                formControlName="frequency"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="1"
                [max]="frequencyConfig.MAX_FREQUENCY"
                suffix=" veces"
                [style]="{'width': '100%'}"
                (onInput)="onFrequencyChange('call')"
              ></p-inputNumber>
            </div>
          </div>
          
          <!-- Intervalo (solo si frequency > 1) -->
          <div class="interval-section" *ngIf="hasMultipleFrequency('call')">
            <div class="form-field">
              <label>Intervalo entre envíos</label>
              <p-inputNumber
                formControlName="frequencyInterval"
                [showButtons]="true"
                buttonLayout="horizontal"
                [min]="frequencyConfig.MIN_INTERVAL"
                [max]="480"
                suffix=" min"
                [style]="{'width': '50%'}"
              ></p-inputNumber>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
